import { defineNuxtPlugin } from '#app';

// Learning-only CodeMirror custom elements (`CodeEditorHintWidget`,
// `CodeEditorAnnotationWidget`) are now registered lazily from
// `~/composables/useLearningCodeEditorWidgets`. Marketing pages no longer pay
// the cost of importing the CodeMirror tree at app init.
export default defineNuxtPlugin(() => {});
